<template>
  <sweet-modal class="modal-reset-styles" ref="invoice_preview_modal">
    <div class="reset-modal-style" v-if="previewedInvoice">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Product</th>
            <th>Qty</th>
            <th>Unit Price</th>
            <th>Description</th>
            <th class="text-right">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="line in previewedInvoice.invoice_lines" :key="line.id">
            <td>{{ line.product_identification }}</td>
            <td>{{ line.quantity }}</td>
            <td>{{ line.unit_price }}</td>
            <td>{{ line.description }}</td>
            <td class="text-right nowrap">
              {{ (line.quantity * line.unit_price).toFixed(2) }}
              {{ previewedInvoice.currency }}
            </td>
          </tr>
        </tbody>
        <tfoot class="bg-primary">
          <tr>
            <td><strong>Sub total</strong></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="text-right nowrap">
              <strong
                >{{ previewedInvoice.sub_total_amount.toFixed(2) }}
                {{ previewedInvoice.currency }}</strong
              >
            </td>
          </tr>
          <tr>
            <td><strong>Vat amount</strong></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="text-right nowrap">
              <strong
                >{{ previewedInvoice.vat_amount.toFixed(2) }}
                {{ previewedInvoice.currency }}</strong
              >
            </td>
          </tr>
          <tr>
            <td><strong>Total</strong></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="text-right nowrap">
              <strong
                >{{ previewedInvoice.total_amount.toFixed(2) }}
                {{ previewedInvoice.currency }}</strong
              >
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </sweet-modal>
</template>

<script>
export default {
  props: {
    previewedInvoice: Object,
  },
  methods: {
    open() {
      this.$refs.invoice_preview_modal.open();
    },
    close() {
      this.$refs.invoice_preview_modal.close();
    },
  },
};
</script>